import ModalClass from './Modal';
import starRating from './../templates/starRating';

export default class VerivoxCompare
{
    constructor($modal) {
        this.Modal = new ModalClass($modal);
    }

    setTariffs(data) {
        this.tariffs = data;
        return this;
    }

    setType(type) {
        this.type = type;
    }

    getRatingCaption(percent) {
        let currentRating = (percent / 100) * 5;
        return  currentRating.toFixed(1) + ' von 5 Sternen';
    }

    getHeadline(content) {
        return `<h3 class="h4">${content}</h3>`;
    }

    getSpan(content, cssClass) {
        if (cssClass) {
            return `<span class=${cssClass}>${content}</span>`;
        }

        return `<span>${content}</span>`;
    }

    checkValue(value) {
        return value === undefined ? '-' : value;
    }

    getEnergyColor(energySource) {
        switch(energySource) {
            case 'Nuklear':
                return '#ffca0e';
            case 'Regenerativ':
                return '#2bbb00';
            case 'Regenerativ (EEG gefördert)':
                return '#107b35';
            case 'sonstige fossile Energieträger':
                return '#9d9d9d';
            case 'Kohle':
                return '#4b4b4b';
            case 'Erdgas':
                return '#4f83dc';
            default:
                return '#0BD789';
        }
    }

    getParagraph(content) {
        return `<p>${content}</p>`;
    }

    getButtonLink(url, label) {
        return `<a class="button success" href="${url}" target="_blank">${label}</a>`;
    }

    getAGBLinkButton(url, label) {
        return `<a class="agb-link" href="${url}" target="_blank">${label}</a>`;
    }

    getTableRowByKey(label, key) {
        let result = '<tr>';
        result += `<td> ${label}</td>`;
        this.compareData.forEach(tariff => {
            result += `<td class="text-center">${this.checkValue(tariff[key])}</td>`;
        });
        result += '</tr>';

        return result;
    }

    getUserRatingRow(label, key, showRating = true) {
        let result = '<tr>';
        result += `<td> ${label}</td>`;

        this.compareData.forEach(tariff => {
            if(showRating) {
                result += `<td class="text-center">`;
                result += '<div class="star-ratings initialized" data-rating="' + tariff.userRating[key].ratingPercent + '">' + starRating(tariff.userRating[key].ratingPercent) + '</div>';
                result += this.getSpan(tariff.userRating[key].ratingCaption, 'block');
                result += `</td>`;
            } else {
                result += `<td class="text-center">${tariff.userRating[key].ratingPercent} %</td>`;
            }
        });
        result += '</tr>';

        return result;
    }

    getAGBLinkRow(label) {
        let result = '<tr>';
        result += `<td> ${label}</td>`;
        this.compareData.forEach(tariff => {
            result += `<td class="text-center">${this.getAGBLinkButton(tariff.agb, 'ansehen')}</td>`;
        });
        result += '</tr>';

        return result;
    }

    getChartHTML(tariff) {
        let chartHTML = `<canvas id="chart-${tariff.id}" height="300" width="300">`;
        tariff.energySources.forEach(energySource => {
            chartHTML += `<div data-value="${energySource.percent}" data-color="${this.getEnergyColor(energySource.caption)}">${energySource.caption}</div>`;
        });
        chartHTML += '</canvas>';

        return chartHTML;
    }

    getEnergySourceTable() {
        let myChart = {};
        let energySourceTable = '<tr>';
        energySourceTable += '<td>Energiequellen</td>';
        this.compareData.forEach(tariff => {
            energySourceTable += '<td>';
            energySourceTable += this.getChartHTML(tariff);
            energySourceTable += '<table class="energySource">';
            tariff.energySources.forEach(energySource => {
                energySourceTable += `<tr><td class="no-border firstRow"><span class="energy-source-bullet" style="background: ${this.getEnergyColor(energySource.caption)}"></span> ${energySource.caption}</td><td class="no-border text-right">${energySource.content}<tr></tr>`;
            });
            energySourceTable += '</table>';
            energySourceTable += '</td>';
        });
        energySourceTable += '</tr>';

        return energySourceTable;
    }

    getProviderTable() {
        let providerTable = '<table>';
        providerTable += '<tr>';
        providerTable += '<td>';
        providerTable += '<p><strong>Aktueller Verbrauch</strong><br>';
        providerTable += '<strong>' + this.compareData[0].annualConsumption + '</strong>/Jahr in <strong>' + this.compareData[0].postCode + ' ' + this.compareData[0].city +  '</strong></p>';
        providerTable += '</td>';

        this.compareData.forEach(provider => {
            providerTable += '<td class="text-center">';
            providerTable += '<div class="logo-box"><img src="' + provider.logo + '"></div>';
            providerTable += this.getParagraph(provider.tariffName);
            providerTable += this.getSpan(provider.cost + ' €', 'price');
            providerTable += this.getSpan('im 1. Jahr', 'price-savings');
            providerTable += this.getSpan(provider.saving + '€ gespart', 'price-saving-sum');
            providerTable += this.getButtonLink(provider.vxcpUrl, 'weiter');
            providerTable += '</td>';
        });

        providerTable += '</tr>';
        providerTable += '<tr>';
        providerTable += '<td>';
        providerTable += 'Kundenbewertung';
        providerTable += '</td>';
        this.compareData.forEach(provider => {
            providerTable += '<td class="text-center">';
            providerTable += `<div class="star-ratings initialized" data-rating="${provider.userRating.customerRating.ratingPercent}">` + starRating(provider.userRating.customerRating.ratingPercent) + '</div>';
            providerTable += this.getSpan('(' + provider.userRating.customerRating.totalReviews + ')', 'caption');
            providerTable += this.getSpan(provider.userRating.customerRating.ratingCaption, 'block');
            providerTable += '</td>';
        });
        providerTable += '</tr>';
        providerTable += '</table>';

        return providerTable;
    }

    getPriceDetailTable() {
        let priceDetailTable = '<table>';
        priceDetailTable += this.getTableRowByKey('Grundpreis', 'basePrice');
        priceDetailTable += this.getTableRowByKey('Arbeitspreis', 'energyPrice');
        priceDetailTable += this.getTableRowByKey('Sofortbonus', 'instantBonus');
        priceDetailTable += this.getTableRowByKey('Neukundenbonus', 'newCustomerBonus');
        priceDetailTable += this.getTableRowByKey('Preisgarantie', 'priceGuarantee');
        priceDetailTable += this.getTableRowByKey('Kaution', 'deposit');
        priceDetailTable += '</table>';

        return priceDetailTable;
    }

    getContractConditionsTable() {
        let contractConditionsTable = '<table>';
        contractConditionsTable += this.getTableRowByKey('Vertragslaufzeit', 'runTime');
        contractConditionsTable += this.getTableRowByKey('Verlängerung', 'renewal');
        contractConditionsTable += this.getTableRowByKey('Kündigungsfrist', 'cancellation');
        contractConditionsTable += this.getAGBLinkRow('AGB');
        contractConditionsTable += '</table>';

        return contractConditionsTable;
    }

    getUserRatingTable() {
        let userRatingTable = '<table>';
        userRatingTable += this.getUserRatingRow('Service', 'price');
        userRatingTable += this.getUserRatingRow('Preis', 'service');
        userRatingTable += this.getUserRatingRow('Anbieterwechsel', 'switching');
        userRatingTable += this.getUserRatingRow('Weiterempfehlung', 'recommendation', false);
        userRatingTable += '<table>';

        return userRatingTable;
    }

    getCurrentCompositionTable() {
        let currentCompositionTableTable = '<table>';
        currentCompositionTableTable += this.getTableRowByKey('Leistungsbewertung in Schulnoten', 'verivoxRating');
        currentCompositionTableTable += this.getEnergySourceTable();
        currentCompositionTableTable += '</table >';

        return currentCompositionTableTable;
    }

    getModalContent() {
        this.prepareData();
        let html = '<div class="compareModal">';
        html += '<row>';
        let compareHeadline = this.type == 'gas' ? 'Gastarif-Vergleich' : 'Stromtarif-Vergleich';
        html += `<div class="column small-6"><h2 class="h4">${compareHeadline}</h2></div>`;
        html += '</row>';
        html += '<row>';
        html += this.getProviderTable();
        html += '</row>';
        html += '<row>';
        html += this.getHeadline('Preisdetails');
        html += this.getPriceDetailTable();
        html += '</row>';
        html += '<row>';
        html += this.getHeadline('Vertragsbedingungen');
        html += this.getContractConditionsTable();
        html += '</row>';
        html += '<row>';
        html += this.getHeadline('Kundenbewertungen');
        html += this.getUserRatingTable();
        html += '</row>';
        html += '<row>';
        if (this.type == 'electricity') {
            html += this.getHeadline('Stromzusammensetzung');
            html += this.getCurrentCompositionTable();
        }
        html += '</row>';
        html += '</div>';

        return html;
    }

    prepareUserRating(tariff) {
        let userRating = {};

        if(tariff.userRatings !== undefined) {
            userRating.service = {
                ratingPercent: tariff.userRatings.additonalCustomerRatings.service['@attributes'].percent,
                ratingCaption: this.getRatingCaption(tariff.userRatings.additonalCustomerRatings.service['@attributes'].percent)
            };
        } else {
            userRating.service = {
                ratingPercent: 0,
                ratingCaption: this.getRatingCaption(0)
            };
        }

        if (tariff.userRatings !== undefined) {
            userRating.price = {
                ratingPercent: tariff.userRatings.additonalCustomerRatings.price['@attributes'].percent,
                ratingCaption: this.getRatingCaption(tariff.userRatings.additonalCustomerRatings.price['@attributes'].percent)
            };
        } else {
            userRating.price = {
                ratingPercent: 0,
                ratingCaption: this.getRatingCaption(0)
            };
        }
        if (tariff.userRatings !== undefined) {
            userRating.switching = {
                ratingPercent: tariff.userRatings.additonalCustomerRatings.switching['@attributes'].percent,
                ratingCaption: this.getRatingCaption(tariff.userRatings.additonalCustomerRatings.switching['@attributes'].percent)
            };
        } else {
            userRating.switching = {
                ratingPercent: 0,
                ratingCaption: this.getRatingCaption(0)
            };
        }

        if (tariff.userRatings !== undefined) {
            userRating.customerRating = {
                ratingPercent: tariff.userRatings.switchAgain['@attributes'].percent,
                totalReviews: tariff.userRatings.switchAgain['@attributes'].totalReviews,
                ratingCaption: this.getRatingCaption(tariff.userRatings.switchAgain['@attributes'].percent)
            };
        } else {
            userRating.customerRating = {
                ratingPercent: 0,
                totalReviews: 0,
                ratingCaption: this.getRatingCaption(0)
            };
        }

        if (tariff.userRatings !== undefined) {
            userRating.recommendation = {
                ratingPercent: tariff.userRatings.switchAgain['@attributes'].percent,
            };
        } else {
            userRating.recommendation = {
                ratingPercent: 0,
            };
        }

        return userRating;
    }

    prepareData() {
        let compareData = [];
        this.tariffs.forEach(tariff => {

            let userRating = {};
            userRating = this.prepareUserRating(tariff);

            let energySources = [];

            // Gas tariffs carry no energySources at all. getModalContent() already
            // renders the Stromzusammensetzung for electricity only, but this ran
            // ahead of that check and dereferenced it unconditionally.
            let sourceList = tariff.energySources
                && tariff.energySources.sources
                && tariff.energySources.sources.list
                ? tariff.energySources.sources.list.source
                : null;

            if (sourceList) {
                if (sourceList[0]) {
                    sourceList.forEach(source => {
                        let energySourceData = {
                            caption: source.caption.text,
                            content: source.content.text,
                            percent: source['@attributes'].percent
                        };
                        energySources.push(energySourceData);
                    });
                } else {
                    energySources.push({
                        caption: sourceList.caption.text,
                        content: sourceList.content.text,
                        percent: sourceList['@attributes'].percent
                    });
                }
            }

            let verivoxRating = '- / -';
            if (tariff.tariff.verivoxRating !== undefined) {
                verivoxRating = `${tariff.tariff.verivoxRating.content.text} / ${tariff.tariff.verivoxRating.caption.text}`;
            }

            let instantBonus = '-';
            let newCustomerBonus = '-';
            if(tariff.tariff.cost.total.costDetails.bonus !== undefined && tariff.tariff.cost.total.costDetails.bonus.costDescriptionItems.costDescriptionItem[0]) {
                tariff.tariff.cost.total.costDetails.bonus.costDescriptionItems.costDescriptionItem.forEach(bonus => {
                    if(bonus.description == 'Neukundenbonus') {
                        newCustomerBonus = bonus.amountFormatted;
                    }
                    if(bonus.description == 'Sofortbonus') {
                        instantBonus = bonus.amountFormatted;
                    }
                });
            } else  {
                if (tariff.tariff.cost.total.costDetails.bonus !== undefined && tariff.tariff.cost.total.costDetails.bonus.costDescriptionItems.costDescriptionItem.description == 'Neukundenbonus') {
                    newCustomerBonus = tariff.tariff.cost.total.costDetails.bonus.costDescriptionItems.costDescriptionItem.amountFormatted;
                }
                if (tariff.tariff.cost.total.costDetails.bonus !== undefined && tariff.tariff.cost.total.costDetails.bonus.costDescriptionItems.costDescriptionItem.description == 'Sofortbonus') {
                    newCustomerBonus = tariff.tariff.cost.total.costDetails.bonus.costDescriptionItems.costDescriptionItem.amountFormatted;
                }
            }

            let data = {
                id: tariff.tariff['@attributes'].id,
                city: tariff.userInput.location.city.content.text,
                postCode: tariff.userInput.location.postCode.content.text,
                annualConsumption: tariff.userInput.usage.annualConsumption.content.text,
                logo:   tariff.provider['@attributes'].logoUrl,
                tariffName: tariff.tariff.content.text,
                cost: tariff.tariff.cost.total.effectiveCost.content.text.substring(0, tariff.tariff.cost.total.effectiveCost.content.text.indexOf("€ ")).trim(),
                saving: (tariff.benchmarkTariff['@attributes'].totalCostInEuro-tariff.tariff.cost.total.effectiveCost['@attributes'].amount).toFixed(2),
                rating: '',
                basePrice: tariff.tariff.cost.subTotal.costDetails.recurringCosts.costDescriptionItems.costDescriptionItem.amountFormatted,
                energyPrice: tariff.tariff.cost.subTotal.costDetails.oneTimeCosts.costDescriptionItems.costDescriptionItem.unitPriceRemark,
                instantBonus: instantBonus,
                newCustomerBonus: newCustomerBonus,
                priceGuarantee: tariff.contractDetails.priceGuarantee.content.text,
                deposit: tariff.contractDetails.deposit.content.text,
                vxcpUrl: tariff.signup.subdomain['@attributes'].url,
                runTime: tariff.contractDetails.contractDuration.content.text,
                renewal: tariff.contractDetails.contractProlongation.content.text,
                cancellation: tariff.contractDetails.cancellationPeriod.content.text,
                agb: `https://www.verivox.de/signup/energie/${this.type == 'gas' ? 'gas' : 'electricity'}/${tariff.tariff['@attributes'].id}/agb/`,
                userRating: userRating,
                verivoxRating: verivoxRating,
                energySources: energySources
            };

            compareData.push(data);
        });

        this.compareData = compareData;
    }
}
